import * as React from "react"

import { USER_ROLE, VISIBILITY_TRACKER_ROUTES } from "@constants"
import AppLayout from "Layout"
import MappingMetricsPage from "./index"


export const VtMappingMetricsRoutes = {
	path: VISIBILITY_TRACKER_ROUTES.MAPPING_METRICS_PATH,
	title: VISIBILITY_TRACKER_ROUTES.MAPPING_METRICS_TITLE,
	// Same icon family as the other dashboards; 'chart-user' is already used
	// elsewhere in the app, so the name is known to resolve.
	icon: 'chart-user',
	iconWeight: 'light',
	element: <AppLayout />,
	description: 'Per-mapper resource reviews — totals in the period and resources/hour',
	access: USER_ROLE.ADMIN,
	children: [{
		element: <MappingMetricsPage />,
		index: true
	}]
}
